import Vue from 'vue'
import VueRouter from 'vue-router'
import TianDiTuMap from '@/components/TianDiTuMap.vue'
import ShipMap from '@/components/ShipMap.vue'
import ShipMap_origin from '@/components/ShipMap_origin.vue'
import ShipMap_d3 from '@/components/ShipMap_d3.vue'
import ShipMap_g6 from '@/components/ShipMap_g6.vue'  
import Dashboard from '@/views/Dashboard.vue'
import ComingSoon from '@/components/ComingSoon.vue'
import Login from '@/views/Login.vue'
import Register from '@/views/Register.vue'
import ChangePassword from '@/views/ChangePassword.vue'
import VideoMonitor from '@/views/VideoMonitor.vue'
import VideoWall from '@/views/VideoWall.vue'
// 引入船舶监控页面
import ShipMonitorNew from '@/views/maritime-new/ShipMonitor.vue'
import ShipMonitor from '@/views/maritime/ShipMonitor.vue'
// 引入船舶航迹页面
import ShipTrajectory from '@/views/maritime-new/ShipTrajectory.vue'
// 引入船舶管理相关页面
import VesselList from '@/views/maritime-new/vessel/VesselList.vue'
import VesselManagement from '@/views/maritime-new/vessel/VesselManagement.vue'
// 引入桥梁相关页面
import BridgeList from '@/views/bridge/BridgeList.vue'
import BridgeManagement from '@/views/bridge/BridgeManagement.vue'
// 引入设备管理相关页面
import DeviceManagement from '@/views/device/DeviceManagement.vue'
// 引入用户管理相关页面
import UserList from '@/views/user/UserList.vue'
import UserManagement from '@/views/user/UserManagement.vue'
import UserBridgeAssociation from '@/views/user/UserBridgeAssociation.vue'
// 引入权限管理相关页面
import RoleManagement from '@/views/permission/RoleManagement.vue'
// 引入系统参数页面
import SystemParams from '@/views/settings/SystemParams.vue'
// 引入告警设置页面
import AlertSettings from '@/views/alert/AlertSettings.vue'
// 引入可视化大屏页面
import DataVisualization from '@/views/DataVisualization.vue'
// 引入数据看板页面
import DataDashboard from '@/views/analytics/DataDashboard.vue'
// 引入统计分析页面
import DeviationAnalytics from '@/views/analytics/DeviationAnalytics.vue'
import SuperelevationAnalytics from '@/views/analytics/SuperelevationAnalytics.vue'
import OverspeedAnalytics from '@/views/analytics/OverspeedAnalytics.vue'
import TrafficAnalytics from '@/views/analytics/TrafficAnalytics.vue'
import ForbidAnalytics from '@/views/analytics/ForbidAnalytics.vue'
import VhfAnalytics from '@/views/analytics/VhfAnalytics.vue'
import AlertAnalytics from '@/views/analytics/AlertAnalytics.vue'
// 引入数据管理页面
import HistoryData from '@/views/data-management/HistoryData.vue'
// 引入权限检查工具
import { hasAdminAccess, routeRequiresAdmin, hasRouteRole, handleInsufficientPermission } from '@/utils/permissionUtils'
// 引入URL Token认证工具
import { getTokenFromUrl, validateTokenAndGetUserInfo, clearTokenFromUrl } from '@/utils/token-auth'

Vue.use(VueRouter)

// 修复：重复导航到当前路由（如再次点击当前所在菜单）时，Vue Router 会抛出
// NavigationDuplicated 未捕获异常。这里统一吞掉该错误，避免控制台报错。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err && err.name === 'NavigationDuplicated') {
      return err
    }
    throw err
  })
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录', public: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { title: '注册', public: true }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: { title: '修改密码' }
  },
  {
    path: '/dashboard',
    name: 'HomeDashboard',
    component: Dashboard,
    meta: { 
      title: '首页',
      requiresAdmin: true  // 需要管理员权限
    }
  },
  {
    path: '/',
    name: 'Home',
    component: ShipMonitorNew,
    meta: { title: '船舶监控' }
  },
  {
    path: '/maritime/monitor',
    name: 'ShipMonitorNew',
    component: ShipMonitorNew,
    meta: { title: '船舶监控' }
  },
  {
    path: '/work/monitor',
    name: 'ShipMonitor',
    component: ShipMonitor,
    meta: { title: '值班监控' }
  },
  // 添加船舶管理相关路由
  {
    path: '/vessel/list',
    name: 'VesselList',
    component: VesselList,
    meta: { 
      title: '船舶列表',
      requiresAdmin: true  // 需要管理员权限
    }
  },
  {
    path: '/vessel/management',
    name: 'VesselManagement',
    component: VesselManagement,
    meta: { 
      title: '船舶管理',
      requiresAdmin: true  // 需要管理员权限
    }
  },
  {
    path: '/video-monitor',
    name: 'VideoMonitor',
    component: VideoMonitor,
    meta: { title: '视频监控' }
  },
  {
    path: '/video-wall',
    name: 'VideoWall',
    component: VideoWall,
    meta: { title: '实时视频', roles: ['ADMIN', 'MONITOR'] }
  },
  // 添加桥梁管理相关路由
  {
    path: '/bridge/list',
    name: 'BridgeList',
    component: BridgeList,
    meta: { 
      title: '桥梁列表',
      requiresAdmin: true  // 需要管理员权限
    }
  },
  {
    path: '/bridge/management',
    name: 'BridgeManagement',
    component: BridgeManagement,
    meta: { 
      title: '桥梁管理',
      requiresAdmin: true  // 需要管理员权限
    }
  },
  // 添加设备管理路由
  {
    path: '/equipment-all',
    name: 'DeviceManagement',
    component: DeviceManagement,
    meta: { 
      title: '设备管理',
      requiresAdmin: false  // 需要管理员权限
    }
  },
  // 添加用户管理相关路由
  {
    path: '/user/list',
    name: 'UserList',
    component: UserList,
    meta: { 
      title: '用户列表',
      requiresAdmin: true  // 需要管理员权限
    }
  },
  {
    path: '/user/management',
    name: 'UserManagement',
    component: UserManagement,
    meta: { 
      title: '添加用户',
      requiresAdmin: true  // 需要管理员权限
    }
  },
  {
    path: '/user/management/:id',
    name: 'UserManagementEdit',
    component: UserManagement,
    meta: { 
      title: '编辑用户',
      requiresAdmin: true  // 需要管理员权限
    }
  },
  {
    path: '/user/bridge-association',
    name: 'UserBridgeAssociation',
    component: UserBridgeAssociation,
    meta: { 
      title: '用户桥梁关联',
      requiresAdmin: true  // 需要管理员权限
    }
  },
  // 添加权限管理相关路由
  {
    path: '/permission/roles',
    name: 'RoleManagement',
    component: RoleManagement, 
    meta: { 
      title: '角色管理',
      requiresAdmin: true  // 需要管理员权限
    }
  },
  {
    path: '/permission/assign',
    redirect: '/permission/roles'
  },
  {
    path: '/gaode',
    name: 'GaoDeMap',
    component: ComingSoon,
    meta: { title: '高德地图' }
  },
  {
    path: '/google',
    name: 'GoogleMap',
    component: ComingSoon,
    meta: { title: 'Google地图' }
  },
  {
    path: '/water',
    name: 'WaterMap',
    component: ComingSoon,
    meta: { title: '水系专题' }
  },
  {
    path: '/analysis',
    name: 'DataAnalysis',
    component: ComingSoon,
    meta: { title: '数据分析' }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: ComingSoon,
    meta: { title: '系统设置' }
  },
  {
    path: '/settings/system-params',
    name: 'SystemParams',
    component: SystemParams,
    meta: { 
      title: '系统参数',
      requiresAdmin: true  // 需要管理员权限
    }
  },
  {
    path: '/alert/settings',
    name: 'AlertSettings',
    component: AlertSettings,
    meta: { 
      title: '告警设置',
      requiresAdmin: true  // 需要管理员权限
    }
  },
  {
    path: '/ship/track',
    name: 'ShipTrajectory',
    component: ShipTrajectory,
    meta: { title: '船舶航迹' }
  },
  // 可视化大屏路由
  {
    path: '/data-visualization',
    name: 'DataVisualization',
    component: DataVisualization,
    meta: { 
      title: '可视化大屏',
      fullscreen: true  // 标记为全屏页面
    }
  },
  // 数据看板路由
  {
    path: '/analytics/dashboard',
    name: 'DataDashboard',
    component: DataDashboard,
    meta: { 
      title: '数据看板'
    }
  },
  // 统计分析路由
  {
    path: '/analytics/deviation',
    name: 'DeviationAnalytics',
    component: DeviationAnalytics,
    meta: {
      title: '桥梁偏航统计'
    }
  },
  {
    path: '/analytics/superelevation',
    name: 'SuperelevationAnalytics',
    component: SuperelevationAnalytics,
    meta: {
      title: '桥梁超高统计'
    }
  },
  {
    path: '/analytics/overspeed',
    name: 'OverspeedAnalytics',
    component: OverspeedAnalytics,
    meta: {
      title: '桥梁超速统计'
    }
  },
  {
    path: '/analytics/traffic',
    name: 'TrafficAnalytics',
    component: TrafficAnalytics,
    meta: {
      title: '流量统计'
    }
  },
  {
    path: '/analytics/forbid',
    name: 'ForbidAnalytics',
    component: ForbidAnalytics,
    meta: {
      title: '桥梁禁航统计'
    }
  },
  {
    path: '/analytics/vhf',
    name: 'VhfAnalytics',
    component: VhfAnalytics,
    meta: {
      title: '桥梁VHF统计'
    }
  },
  {
    path: '/analytics/alert',
    name: 'AlertAnalytics',
    component: AlertAnalytics,
    meta: {
      title: '桥梁预警统计'
    }
  },
  // 数据管理路由
  {
    path: '/data-management/history',
    name: 'HistoryData',
    component: HistoryData,
    meta: {
      title: '桥梁检测'
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 标记是否正在处理URL Token认证，避免重复处理
let isProcessingUrlToken = false

// 全局导航守卫
router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - 桥卫士` : '桥卫士'
  
  // 检查URL中是否有token参数（用于第三方iframe免登录）
  const urlToken = getTokenFromUrl()
  
  // 如果URL中有token且未在处理中，先处理token认证
  if (urlToken && !isProcessingUrlToken) {
    isProcessingUrlToken = true
    console.log('[Router] 检测到URL中的token参数，尝试自动登录...')
    
    try {
      const result = await validateTokenAndGetUserInfo(urlToken)
      
      if (result.success) {
        console.log('[Router] URL Token验证成功，用户:', result.userInfo?.username)
        // 清除URL中的token参数，保持URL整洁
        clearTokenFromUrl()
        
        // 继续正常的路由流程
        isProcessingUrlToken = false
        
        // 如果目标是登录页，重定向到首页
        if (to.path === '/login') {
          next({ path: '/' })
          return
        }
      } else {
        console.warn('[Router] URL Token验证失败:', result.error)
        // 清除无效的token
        clearTokenFromUrl()
      }
    } catch (error) {
      console.error('[Router] URL Token处理异常:', error)
      clearTokenFromUrl()
    }
    
    isProcessingUrlToken = false
  }
  
  // 获取token（可能是URL token认证后保存的，也可能是之前登录保存的）
  const token = localStorage.getItem('token')
  // 角色级页面访问控制：仅允许 meta.roles 中列出的角色访问（如"实时视频"仅管理员/值班室）
  if (token && to.meta && Array.isArray(to.meta.roles) && to.meta.roles.length && !hasRouteRole(to)) {
    handleInsufficientPermission(router, from, '该功能仅管理员或值班室可访问');
    next(false);
    return;
  }
  
  // 如果访问的是不需要权限的页面（如登录、注册），直接放行
  if (to.matched.some(record => record.meta.public)) {
    // 如果已登录且要前往登录页，则重定向到首页
    if (token && to.path === '/login') {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    // 需要权限的页面
    if (token) {
      // 检查是否需要管理员权限
      if (routeRequiresAdmin(to)) {
        if (hasAdminAccess()) {
          // 有管理员权限，放行
          next();
        } else {
          // 无管理员权限，使用工具函数处理
          handleInsufficientPermission(router, from);
          next(false); // 阻止导航
        }
      } else {
        // 不需要管理员权限，有token就放行
        next();
      }
    } else {
      // 无token，重定向到登录页并保存要前往的地址
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  }
})

export default router 